import React, { Component } from "react";
import { Row, Col } from "reactstrap";
import { toastrMessage } from "helpers/messageHelper";
import { formatDate, formatDateTime } from "helpers/generalUtils";
import { SUCCESS, DANGER } from "constants/commonConstants";
import moment from "moment";

import { getOrderDetailListRequest } from "store/actions";

import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { compose } from "redux";
import { makeOrderDetailSelectField } from "store/OrderDetail/selector";
import { createStructuredSelector } from "reselect";
import CustomDataTable from "components/Application/CustomDataTable";
import OrderStatus from "./OrderStatus";
import CircularIconButton from "components/Buttons/CircularIconButton";

const columns = [
  {
    label: "Order number",
    field: "orderNo",
  },
  {
    label: "Date",
    field: "orderDate",
  },
  {
    label: "Username",
    field: "username",
  },
  {
    label: "Status",
    field: "status",
    sort: "disabled",
  },
  {
    label: "Total SP",
    field: "orderSp",
  },
  {
    label: "C.Disc",
    field: "couponDiscount",
  },
  {
    label: "Dely Chg",
    field: "deliveryCharges",
  },
  {
    label: "Total Amount",
    field: "totalOrderAmount",
  },
  {
    label: "Actions",
    field: "actions",
    sort: "disabled",
  },
];

class OrderDetailList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orderDetailRecords: [],
      startDate: formatDate(moment(new Date()).subtract(1, "months")),
      endDate: formatDate(new Date()),
    };
  }

  componentDidMount() {
    //Retrieve order list
    this.props.getOrderDetailListRequest({
      fromDate: this.state.startDate,
      toDate: this.state.endDate,
    });
  }

  UNSAFE_componentWillReceiveProps(nextprops) {
    if (this.props.orderDetailData !== nextprops.orderDetailData) {
      this.buildOrderDataTable(nextprops.orderDetailData);
    }
    if (
      this.props.orderDetailApiResponse !== nextprops.orderDetailApiResponse
    ) {
      if (nextprops.orderDetailApiResponse.isSuccessResponse) {
        toastrMessage(
          nextprops.orderDetailApiResponse.responseMessage,
          SUCCESS
        );
        this.props.getOrderDetailListRequest({
          fromDate: this.state.startDate,
          toDate: this.state.endDate,
        });
      } else if (!nextprops.orderDetailApiResponse.isSuccessResponse) {
        toastrMessage(nextprops.orderDetailApiResponse.responseMessage, DANGER);
      }
    }
  }

  buildOrderDataTable = (records) => {
    this.setState({
      orderDetailRecords: records.map((orderDetail) => {
        let actions = (
          <div className="text-center">
            <CircularIconButton
              icon="far fa-eye fa-lg"
              onClick={this.viewOrder(orderDetail)}
              tooltip={"View Order"}
            />

            <CircularIconButton
              icon="fa fa-clipboard-list fa-lg"
              onClick={this.viewFeedback(orderDetail)}
              tooltip={"View Feedback"}
              disabled={parseInt(orderDetail.orderStatus) !== 3}
            />

            <CircularIconButton
              icon="fa fa-download fa-lg"
              onClick={this.downloadInvoice(orderDetail)}
              tooltip={"Download Invoice"}
              disabled={parseInt(orderDetail.orderStatus) !== 3}
            />
          </div>
        );

        let status = (
          <OrderStatus
            status={orderDetail.orderStatus}
            orderId={orderDetail.orderDetailId}
          />
        );

        return {
          orderNo: orderDetail.orderNo,
          orderDate: formatDateTime(orderDetail.orderDate),
          status: status,
          username: orderDetail.username,
          orderSp: orderDetail.orderSp,
          couponDiscount: "-" + (orderDetail.couponDisc || 0),
          deliveryCharges: "+" + (orderDetail.deliveryCharges || 0),
          totalOrderAmount: orderDetail.totalOrderAmount,
          actions: actions,
        };
      }),
    });
  };

  viewOrder = (orderDetailData) => () => {
    this.props.onViewOrder(orderDetailData);
  };

  viewFeedback = (orderDetailData) => () => {
    this.props.onFeedbackView(orderDetailData);
  };

  downloadInvoice = (orderDetailData) => () => {
    this.props.onDownloadInvoice(orderDetailData);
  };

  onChangeStartDate = (e) => {
    const date = e.target.value;
    // if end date is less than start date
    if (new Date(this.state.endDate) < new Date(date)) {
      this.setState({ startDate: date, endDate: date });
    } else this.setState({ startDate: date });
  };

  onChangeEndDate = (e) => {
    const date = e.target.value;
    // if end date is less than start date
    if (new Date(this.state.startDate) > new Date(date)) {
      this.setState({ startDate: date, endDate: date });
    } else this.setState({ endDate: date });
  };

  findOrdersFilter = () => {
    this.props.getOrderDetailListRequest({
      fromDate: this.state.startDate,
      toDate: this.state.endDate,
    });
  };

  render() {
    const data = {
      columns: columns,
      rows: this.state.orderDetailRecords,
    };

    return (
      <React.Fragment>
        <Row className="form-group my-2">
          <label className="col-4 col-md-2 col-lg-2 col-form-label">
            Start Date:
          </label>
          <Col xs="8" md="4" lg="3" className="my-2">
            <input
              type="date"
              onChange={this.onChangeStartDate}
              value={this.state.startDate}
              className="form-control"
            />
          </Col>
          <label className="col-4 col-md-2 col-lg-2 col-form-label">
            End Date:
          </label>
          <Col xs="8" md="4" lg="3" className="my-2">
            <input
              type="date"
              onChange={this.onChangeEndDate}
              value={this.state.endDate}
              className="form-control"
            />
          </Col>
          <Col xs="12" lg="2" className="my-2">
            <button
              className="btn btn-primary float-right"
              onClick={this.findOrdersFilter}
            >
              Find Orders
            </button>
          </Col>
        </Row>
        <CustomDataTable data={data} />
      </React.Fragment>
    );
  }
}

const mapStatetoProps = createStructuredSelector({
  orderDetailData: makeOrderDetailSelectField("orderDetailData"),
  orderDetailApiResponse: makeOrderDetailSelectField("orderDetailApiResponse"),
});

const withConnect = connect(mapStatetoProps, {
  getOrderDetailListRequest,
});

export default compose(withConnect, withRouter)(OrderDetailList);
